import './split-chart-menu-sk';
